import { Box, Button, Divider, IconButton, InputBase, Pagination, Paper, Stack, TextField, Tooltip, Typography } from "@mui/material";
import LoadingCircle from "../../utils/LoadingCircle";
import Toast from "../../utils/Toast";
import { useEffect, useRef, useState } from "react";
import { ModelHandler } from "../../interface/model-handler";
import { v4 as uuidv4 } from 'uuid';

import AiMore from "../aiUtils/AiMore";
import "./MakePressCheck.css";
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { HttpMainApi } from "../../interface/main-api";
import { useNavigate, useParams } from "react-router-dom";
import { userState } from "../../interface/MainInterface";
import { HttpCustomApi } from "../../interface/custom-api";
import SuggestionDrawer from "./SuggestionDrawer";
import SuggestionDrawer2 from "./SuggestionDrawer2";
import { stream } from "xlsx";
import { Vectocore } from "vectocore";

type ReplacementItem = {
  text: string;
  isStreaming: boolean;
};

interface propsType {
  userState: userState;
}

interface ErrorItem {
  id: string;
  errorContent: string;
  replacement: ReplacementItem[];
}

const mainApi = new HttpMainApi();
const vectocore = new Vectocore({ baseURL: process.env.REACT_APP_VECTOCORE_BASE_URL, tenantKey: process.env.REACT_APP_VECTOCORE_TENANT_KEY });
// const vectoCoreApi = new HttpCustomApi(process.env.REACT_APP_VECTOR_CORE);

const MakePressCheck2_1 = (props: propsType) => {
  const navigate = useNavigate();
  const { pressSeq } = useParams();

  const toastRef: any = useRef();
  const scrollRef: any = useRef();

  const [atBottom, setAtBottom] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  // const [editMode, setEditMode] = useState(true);
  const [text, setText] = useState("");
  const [result, setResult] = useState("");
  const [editedPress, setEditedPress] = useState<string[]>([]);
  const [selectedPress, setSelectedPress] = useState<string>("");

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [globalCommand, setGlobalCommand] = useState("");
  const [hasClicked, setHasClicked] = useState(false);  // 최초 클릭 여부
  const [pressInfo, setPressInfo] = useState<any>({});

  const [model, setModel] = useState("");
  const modelHandler = new ModelHandler(model);
  const [aiApi, handleStreamResponse] = modelHandler.getModelElements();
  const [streamReader, setStreamReader] = useState<ReadableStreamDefaultReader | null>(null);

  const drawerWidth = 700;
  
  useEffect(() => {
    modelHandler
    .getUsingModel()
    .then((usingModel) => {
      setModel(usingModel);
    })
    .catch((errorMsg: any) => {
      toastRef.current?.toast("" + errorMsg, "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
    });

    return () => {
      setIsLoading(false);
      // setEditMode(true);
      setText("");
      setResult("");
      setEditedPress([]);
      setSelectedPress("");
      setDrawerOpen(false);
      setHasClicked(false);
      setGlobalCommand("");
    };
  }, []);

  useEffect(() => {
    if (pressSeq !== undefined) {
      setIsLoading(false);
      // setEditMode(true);
      setPressInfo({});
      setText("");
      setResult("");
      setEditedPress([]);
      setSelectedPress("");
      setDrawerOpen(false);
      setHasClicked(false);
      setGlobalCommand("");
      getPressInfo(pressSeq, true);
    }
  }, [pressSeq]);

  useEffect(() => {
    console.log("text: ", text);
    const el = scrollRef.current;
    if (!el) return;
    handleScroll(); // 초기 상태 설정
  }, [text]);

  useEffect(() => {
    if (!pressInfo.aiResult && editedPress.length > 0) {
      console.log("여기옴,");
      handleHasClicked();
    }
  }, [editedPress]);

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;

    const scrollTop = el.scrollTop;
    const scrollHeight = el.scrollHeight;
    const clientHeight = el.clientHeight;

    setAtBottom(scrollTop + clientHeight >= scrollHeight - 5);
  };

  const handleHasClicked = () => {
    if (!hasClicked) {
      // 페이지 진입 후 최초 클릭 시에만 실행됨. (홍보실 접수)
      takeOverPress();
      setHasClicked(true);
    }
  };

  // 보도자료 임시저장
  const handleSaveDraft = async () => {
    if (!window.confirm("지금까지 작성한 내용을 저장하시겠습니까?")) {
      return;
    } else {
      await modifyResult();
      toastRef.current?.toast(
        "보도자료를 저장했습니다.",
        "success",
        3000,
        {
          vertical: "top",
          horizontal: "center"
        }
      );
    }
  };

  const handleCompletePress = async () => {
    await modifyResult();
    await completePress();
    window.location.href = `/myTotalList`;
  }

  // 보도자료 조회
  const getPressInfo = async (seq: string, isFirstCall: boolean = false) => {
    const param: any = {
      command: "get_press_info",
      sk: seq,
    };

    const res = await mainApi.post(param);
    if (res.code === "200") {
      // console.log("press info : ", res.response.press_info);
      setPressInfo(res.response.press_info);
      if (isFirstCall && res.response.press_info.result) {  // 이미 작성된 보도자료가 있으면 가져옴 (최신으로)
        setText(res.response.press_info.result);

        if (res.response.press_info.aiResult) {
          setEditedPress(res.response.press_info.aiResult);
          setDrawerOpen(true);
        }
      }
    }
  };

  // 홍보실 접수
  const takeOverPress = async () => {
    console.log("editedPress: ", editedPress);
    // console.log("text: ", text);

    // const param: any = {
    //   command: "take_over_press_with_draft",
    //   press_info: pressInfo,
    //   draft: text,
    // };
    const param: any = {
      command: "take_over_press_with_draft",
      pk: "press_info",
      sk: pressSeq,
      hongbo_user_id: props.userState.id,
      hongbo_user_name: props.userState.name,
      draft: text,
      aiResult: editedPress ?? [],
    };
    console.log("takeOverPress param: ", param);

    // setIsLoading(true);
    const res = await mainApi.post(param);
    if (res.code === "200") {
      getPressInfo(pressInfo.sk);
    } else {
      console.error(res.response.error_msg);
      toastRef.current?.toast("" + res.response.error_msg, "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
    }
    // setIsLoading(false);
  }

  // 수정본 결과 저장 
  const modifyResult = async () => {
    let newPressInfo = { ...pressInfo };
    newPressInfo.result = text;
    newPressInfo.aiResult = editedPress;
    // console.log("modifyResult newPressInfo: ", newPressInfo);

    setPressInfo(newPressInfo);
    const param: any = {
      command: "put_press_info",
      press_info: newPressInfo
    };

    await mainApi.post(param);
    getPressInfo(pressInfo.sk);
  }

  // 홍보실 최종 완료
  const completePress = async () => {
    if (
      !window.confirm(
        "최종 완료하시겠습니까?\n최종 완료된 보도자료는 더이상 수정할 수 없습니다."
      )
    )
      return;
  
    // console.log("completePress pressInfo: ", pressInfo);
    setIsLoading(true);
    // 테마 임베딩
    let ebdText: any = pressInfo.form_data;
    ebdText.title = pressInfo.title;
    
    const ebdParam = {
      command: "keywords",
      model: "gpt-4o",
      text: JSON.stringify(ebdText)
    }

    const vectorRes = await aiApi.postStream(ebdParam);
    console.log("vectorRes : ", vectorRes);
    if (vectorRes.code !== "200") {
      console.error(vectorRes.response.error_msg);
      toastRef.current?.toast(
        "" + vectorRes.response.error_msg,
        "error",
        4000,
        { vertical: "top", horizontal: "center" }
      );
      setIsLoading(false);
      return;
    }
  
    // itne vectore db insert
    const itneParam: any = {
      indexName: "press_release_embeddings",
      docBody: {
        "id": pressInfo.sk,
        "keywords": vectorRes.response.keywords,
        "data": pressInfo
      }
    };
  
    const vectorResult = await vectocore.putExtreamData(itneParam);
    console.log("vectorResult : ", vectorResult);
    if (vectorResult.code !== "200") {
      console.error(vectorResult.response.error_msg);
      toastRef.current?.toast(
        "" + vectorResult.response.error_msg,
        "error",
        4000,
        { vertical: "top", horizontal: "center" }
      );
      setIsLoading(false);
      return;
    }
  
    // 홍보실 전송 comment 저장
    // 보도자료 상태 변경
    const param: any = {
      command: "complete_press",
      press_info: pressInfo,
      comment_info: {
        user_id: props.userState.id,
        user_name: props.userState.name,
        type: "complete",
        comment: "",
      },
    };
  
    const res = await mainApi.post(param);
    if (res.code === "200") {
      getPressInfo(pressInfo.sk);
    } else {
      console.error(res.response.error_msg);
      toastRef.current?.toast("" + res.response.error_msg, "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
    }
    setIsLoading(false);
  };

  const splitTextByLength = (text: string, maxLength: number) => {
    const sentences = text.match(/[^.!?]+[.!?]+[\])'"`’”]*|\s*$/g) || [];
    const parts: string[] = [];
    let buffer = "";

    for (const sentence of sentences) {
      if ((buffer + sentence).length <= maxLength) {
        buffer += sentence;
      } else {
        parts.push(buffer.trim());
        buffer = sentence;
      }
    } 
    if (buffer.trim()) parts.push(buffer.trim());
    return parts;
  };

  const splitTextByParagraph = (text: string, maxLength: number) => {
    // 문단 기준으로 먼저 나눔 (두 줄 이상 띄운 경우를 문단으로 간주)
    const paragraphs = text.split(/\n\s*\n/);
    const parts: string[] = [];
    let buffer = "";

    for (const para of paragraphs) {
      const trimmed = para.trim();
      if (!trimmed) continue;

      // 현재 buffer에 추가해도 maxLength를 넘지 않으면 이어붙임
      if ((buffer + "\n\n" + trimmed).trim().length <= maxLength) {
        buffer += (buffer ? "\n\n" : "") + trimmed;
      } else {
        if (buffer) parts.push(buffer.trim());
        buffer = trimmed;
      }
    }

    if (buffer.trim()) parts.push(buffer.trim());
    return parts;
  };

  const generatePrompt = (command: string, draft: string) => {
    return {
      command: command,
      userCommand: globalCommand,
      draft: draft,
    };
  }

  const processAllPress = async (command: string, press: string, maxLength = 800): Promise<string> => {
    // const parts = splitTextByParagraph(press, maxLength);
    const prompt = generatePrompt(command, press);
    console.log("prompts: ", prompt);

    try {
      // 2. 단일 스트림 요청 실행
      const streamResponse = await aiApi.postStream(prompt);
      const result = await genStreamResponse(streamResponse);
      
      console.log(`[${command}] 응답 완료`);
      return result;
    } catch (error) {
      console.error(`[${command}] 처리 중 오류 발생:`, error);
      throw error; // 상위 호출부(deskPress)의 Promise.allSettled에서 캐치됨
    }

    // const responses = await Promise.all(prompts.map(async (prompt) => {
    //   const streamResponse = await aiApi.postStream(prompt);
    //   const result = await genStreamResponse(streamResponse);
    //   return result;
    // }));
    // console.log("responses: ", responses);

    // const mergePrompt = {
    //   command: "desk_press_release_merge",
    //   draft: responses.join("\n\n")
    // };

    // const streamResponse = await aiApi.postStream(mergePrompt);
    // const finalArticle = await genStreamResponse(streamResponse);
    // console.log("finalArticle: ", finalArticle);
    
    // return responses.join("\n\n");
  }

  const deskHeadline = async () => {
    try {
      const headline = {
        command: "desk_press_headline_set_v2",
        userCommand: globalCommand,
        draft: text,
      };

      const [
        streamResponse1,
        streamResponse2,
        streamResponse3
      ] = await Promise.all([
        aiApi.postStream(headline),
        aiApi.postStream(headline),
        aiApi.postStream(headline),
      ]);

      const [
        result1,
        result2,
        result3
      ] = await Promise.all([
        genStreamResponse(streamResponse1),
        genStreamResponse(streamResponse2),
        genStreamResponse(streamResponse3)
      ]);

      return [result1, result2, result3];
    } catch (error) {
      console.error("Error fetching spell check: ", error);
      return [];
    }
  };

  const deskLeadline = async () => {
    try {
      const headline = {
        command: "desk_press_leadline",
        userCommand: globalCommand,
        draft: text,
      };

      const [
        streamResponse1,
        streamResponse2,
        streamResponse3
      ] = await Promise.all([
        aiApi.postStream(headline),
        aiApi.postStream(headline),
        aiApi.postStream(headline),
      ]);

      const [
        result1,
        result2,
        result3
      ] = await Promise.all([
        genStreamResponse(streamResponse1),
        genStreamResponse(streamResponse2),
        genStreamResponse(streamResponse3)
      ]);

      console.log("leadline1: ", result1);
      console.log("leadline2: ", result2);
      console.log("leadline3: ", result3);

      return [result1, result2, result3];
    } catch (error) {
      console.error("Error fetching spell check: ", error);
      return [];
    }
  };

  const deskPress = async () => {
    setIsLoading(true);

    try {
      const [headline1, headline2, headline3] = await deskHeadline();
      // const [leadline1, leadline2, leadline3] = await deskLeadline();

      const [result1, result2, result3] = await Promise.all([
        processAllPress("desk_press_release_v1_test", text, 900),
        processAllPress("desk_press_release_v2_test", text, 900),
        processAllPress("desk_press_release_v3_test", text, 900),
      ]);

      const [
        press1,
        press2,
        press3
      ] = [
        headline1 + '\n\n' + result1,
        headline2 + '\n\n' + result2,
        headline3 + '\n\n' + result3,
      ]

      setEditedPress(prev => [...prev, press1, press2, press3]);
    } catch (error) {
      console.error("Error fetching spell check: ", error);
    }

    setIsLoading(false);
    setDrawerOpen(true);
  };

  const genStreamResponse = async (streamRes: ReadableStream): Promise<string> => {
    const reader = streamRes?.getReader();
    const decoder = new TextDecoder();

    let done = false;
    let content = "";

    while (!done) {
      const { value, done: doneReading } = await reader.read();
      done = doneReading; // 스트림 완료시 true
      const chunkValue = decoder.decode(value);
      content = content + chunkValue;
    }
    try {
      content = content
        .replace(/^```json\s*/, '')  // 앞부분 제거
        .replace(/```$/, '')         // 뒷부분 제거
        .trim();

      return content;
    } catch (error) {
      // console.log("content: ", content);
      // console.log("content Type: ", typeof content);
      return JSON.stringify({ code: "500", response: { error_msg: "json parse error" } });
    }
  };

  const updatePressAt = (index: number, newValue: string) => {
    setEditedPress(prev => {
      const updated = [...prev];
      updated[index] = newValue;
      return updated;
    });
  };

  const changeResult = async (newResult: string) => {
    // setText(resultRef.current.innerText);
  };

  const goSpellCheck = () => {
    let newPressInfo = { ...pressInfo };
    newPressInfo.result = text;
    navigate("/spellCheck", { state: { pressInfo: newPressInfo }});
  };

  return (
    <>
    <div
      style={{ 
        display: "flex",
        justifyContent: drawerOpen ? "space-between" : "center",
        alignItems: "center",
        width: "100%",
        height: "calc(100vh - 44px)",
        boxSizing: "border-box",
        paddingRight: drawerOpen ? "32px" : 0,
        paddingLeft: drawerOpen ? "6%" : 0, // 좌측 여백도 추가 가능
        gap: "6%",
        transition: "all 0.3s ease"
      }}
    >
      <div 
        style={{
          flex: drawerOpen ? 1 : "none",
          maxWidth: drawerOpen ? "45%" : "clamp(500px, 700px, 700px)",
          width: '100%',
          transition: "all 0.3s ease"
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            // justifyContent: 'space-between', // 콘텐츠와 프롬프트창을 위/아래로 나눔
            height: 'calc(100vh - 44px)', // 화면 전체 높이 사용
            width: '100%',
            overflow: 'hidden',
            boxSizing: 'border-box',
            transition: 'padding-right 0.3s ease',
            // pr: drawerOpen ? `${drawerWidth}px` : 0, // ← 여기서 Drawer 너비만큼 밀어줌
          }}
        >
        <div style={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto', overflow: 'hidden' }}>
          {/* 제목: 스크롤 영역 외부 */}
          <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            maxWidth: '700px',
            mx: 'auto',
            mt: '62px',
            mb: '32px',
          }}
          >
            <Box sx={{ fontSize: '1.5rem', fontWeight: 'bold' }}>내가 작성한 기사</Box>
            <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
              <Box 
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  fontSize: '14px', 
                  fontWeight: '600', 
                  color: '#5D88F1', 
                  fontFamily: 'Pretendard',
                  padding: '7px 12px',
                  backgroundColor: '#5D88F11A',
                  borderRadius: '8px',
                  cursor: 'pointer'
                }}
                onClick={goSpellCheck}
              >
                {/* <img src="/images/icon-spellcheck.png" style={{ width: '14px', height: '14px' }}/> */}
                맞춤법 검사
              </Box>

              <Box 
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  fontSize: '14px', 
                  fontWeight: '600', 
                  color: '#5D88F1', 
                  fontFamily: 'Pretendard',
                  padding: '7px 12px',
                  backgroundColor: '#5D88F11A',
                  borderRadius: '8px',
                  cursor: 'pointer'
                }}
                onClick={handleSaveDraft}
              >
                {/* <img src="/images/icon-spellcheck.png" style={{ width: '14px', height: '14px' }}/> */}
                임시저장
              </Box>

              <Box 
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  fontSize: '14px', 
                  fontWeight: '500', 
                  color: '#fff', 
                  fontFamily: 'Pretendard',
                  padding: '7px 12px',
                  backgroundColor: '#5D88F1',
                  borderRadius: '8px',
                  cursor: 'pointer'
                }}
                onClick={() => handleCompletePress()}
              >
                {/* 적용 */}
                {/* <TaskOutlinedIcon 
                  sx={{
                    color: "#fff",
                    fontSize: 15, // 아이콘 크기 조절 (선택)
                    // mr: '0px',   // 왼쪽으로 살짝 당겨서 간격 줄이기 (선택)
                  }}
                /> */}
                완료
              </Box>
            </Box>
          </Box>
          {/* 콘텐츠 영역 (스크롤 가능) */}
          <Box
            sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto', overflow: 'hidden', position: 'relative' }}
          >
            <Box
              ref={scrollRef}
              onScroll={handleScroll}
              sx={{
                flex: '1 1 auto',
                width: '100%',
                maxWidth: '700px',
                maxHeight: !drawerOpen ? 'calc(100vh - 372px)' : 'calc(100vh - 230px)', // 적절한 높이 설정 필요
                mx: 'auto',
                overflowY: 'auto',
                '&::-webkit-scrollbar': { display: 'none' },
                '-ms-overflow-style': 'none',
                'scrollbar-width': 'none',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  backgroundColor: 'white',
                  borderRadius: 2,
                  minHeight: '200px',
                  // pb: 4,
                }}
              >
                <InputBase
                  multiline
                  fullWidth
                  minRows={6}
                  placeholder="여기에 기사 초안을 작성하세요..."
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  sx={{
                    display: 'flex',
                    // display: editMode ? 'flex' : 'none',
                    whiteSpace: 'pre-wrap',
                    lineHeight: 1.6,
                    // mt: '20px',
                    mb: '60px'
                  }}
                />
              </Box>
            </Box>
            
            {/* 하단 고정 Gradient (스크롤 시 사라짐) */}
            {!atBottom && scrollRef.current?.scrollHeight > scrollRef.current?.clientHeight && (
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '100px',
                  background: 'linear-gradient(to top, white 0%, rgba(255,255,255,0) 100%)',
                  pointerEvents: 'none',
                  zIndex: 1,
                  mb: drawerOpen ? '52px': '0px'
                }}
              />
            )}
          </Box>
        </div>
        <div>
          {/* 왼쪽 하단 영역 */}
          {!drawerOpen && 
          <Paper
            component="form"
            elevation={3}
            onSubmit={(e) => {
              e.preventDefault();
              // handleHasClicked();
              deskPress();
            }}
            sx={{
              width: '100%',
              maxWidth: '700px',
              mx: 'auto',
              mb: 8,
              mt: 5,
              display: 'flex',
              flexDirection: 'column', // 새로 정렬
              alignItems: 'center',
              borderRadius: '15px',
              backgroundColor: '#F5F5F5',
              boxShadow: '0 0px 0px rgba(0, 0, 0, 0.1)',
            }}
          >
            <InputBase
              multiline
              maxRows={9}
              sx={{
                // flex: 1,
                width: '100%',
                height: '100%',
                overflowY: 'auto',
                '&::-webkit-scrollbar': { display: 'none' },
                '-ms-overflow-style': 'none',
                'scrollbar-width': 'none',
                color: '#333',
                '&::placeholder': { color: '#a8a8b3' },
                p: '14px 20px',
                '& textarea': {
                  backgroundColor: 'transparent',
                  lineHeight: 1.5,

                  // 스크롤바 투명 처리
                  // FireFox 
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#ECECEC transparent',

                  // WebKit (Chrome, Safari)
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: 'transparent', // 트랙 배경 투명
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#ECECEC', // 필요 시 스크롤바 컬러 조절
                    borderRadius: '3px',
                  },
                },
              }}
              placeholder="추가 요청사항을 입력하거나, 바로 전송해 보도자료를 받아보세요."
              value={globalCommand}
              onChange={(e) => setGlobalCommand(e.target.value)}
            />

            {/* 버튼 영역 */}
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: 1,
              }}
            >
              <IconButton
                type="submit"
                sx={{
                  backgroundColor: '#2E3341',
                  color: '#fff',
                  width: 32,
                  height: 32,
                  // ml: 1,
                  mr: 2,
                  mb: 2,
                  borderRadius: '50%',
                  '&:hover': {
                    opacity: 0.8,
                  },
                }}
              >
                <ArrowUpwardIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Box>
          </Paper>
          }
        </div>
        </Box>
      </div>

      {drawerOpen && (
        <div
          style={{
            width: "49%", // 필요시 % 조절
            minWidth: "200px",
            marginRight: "0", // 오른쪽 끝 고정
            transition: "all 0.3s ease"
          }}
        >
        <SuggestionDrawer2
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          draft={text}
          pressList={editedPress}
          onUpdatePress={updatePressAt}
        />
        </div>
      )}
    </div>

    {/* 로딩바 */}
    <LoadingCircle loading={isLoading} />
    {/* 알림 토스트 */}
    <Toast ref={toastRef} />
    </>
  )
}

export default MakePressCheck2_1;